import db from "../firebase";
import React, { useState } from "react";
import {
  query,
  // doc,
  where,
  getCountFromServer,
  collection,
} from "firebase/firestore";
import { Button, Card, Typography } from "@material-tailwind/react";
// import { useDocument } from "react-firebase-hooks/firestore";

const queryListingAggregationCount = query(
  collection(db, "listing_aggregations_v1"),
  where("version", ">=", 4 )
);

// const queryStorageMigrated = query(
//   collectionGroup(db, "listing_scrapes"),
//   where("sm", "==", true)
// );

// const queryListing = query(doc(db, `migrations/markHasHtml`));


const ListingAggregationStatus = () => {
  const [listingAggregationsCount, setListingAggregationsCount] = useState();
  // const [version5Count, setVersion5Count] = useState();
  // const [bPATHCount, setBPATHCount] = useState();
  // const [HTMLCount, setHTMLCount] = useState();
  // const [HASHTMLCount, setHASHTMLCount] = useState();
  // const [HASJSON2Count, setHASJSON2Count] = useState();
  // const [migratedCount, setMigratedCount] = useState();
  // const [storageMigratedCount, setStorageMigratedCount] = useState();

  // const [allListingScrapes, setAllListingScrapesCount] = useState();

  // const [JSON2Count, setJSON2Count] = useState();

  // const queryListingAggregationsNoLimit = query(
  //   collection(db, "listing_aggregations_v1")
  // );

  // const queryListingAggregationsV5 = query(
  //   collection(db, "listing_aggregations_v1"),
  //   where("version", "==", 5.0)
  // );

  // const queryListingAggregationsBPATH = query(
  //   collectionGroup(db, "listing_scrapes"),
  //   where("bPath", "!=", "_PLACEHOLDER_")
  // );

  // const queryListingAggregationsHTML = query(
  //   collectionGroup(db, "listing_scrapes"),
  //   where("html", "!=", "_PLACEHOLDER_")
  // );

  // const queryListingAggregationsHAS_HTML = query(
  //   collectionGroup(db, "listing_scrapes"),
  //   where("hasHtml", "==", true)
  // );

  // const queryListingAggregationsHAS_JSON2 = query(
  //   collectionGroup(db, "listing_scrapes"),
  //   where("hasJson2", "==", true)
  // );

  // const queryListingAggregationsHAS_JSON = query(
  //   collectionGroup(db, "listing_scrapes"),
  //   where("hasJson", "==", true)
  // );

  // const queryAllListingScrapes = query(
  //   collectionGroup(db, "listing_scrapes"),
  // );

  // const [value] = useDocument(queryListing);
  // const breakdown = value?.data();

  const getCounts = async () => {
      const listingAggregationCount = getCountFromServer(queryListingAggregationCount);
      // const storageMigratedSnap = getCountFromServer(queryStorageMigrated)

      // const proms = await Promise.all([migragedSnap])
      const proms = await Promise.all([listingAggregationCount])
      // setMigratedCount(proms[0].data().count);
      setListingAggregationsCount(proms[0].data().count);
  };

  const [loading, setLoading] = useState(false);

  const fetchCount = async () => {
    setLoading(true);
    try {
      await getCounts();
    } catch (error) {
      console.error("Failed to fetch count:", error);
    }
    setLoading(false);
  };

  return (
    <div>

      {/* <h1>Processed</h1>
        <Typography variant="h1" className="text-4xl">
          {breakdown?.processed.toLocaleString()|| '-'}
        </Typography>
        <h1>Migrated</h1>
        <Typography variant="h1" className="text-4xl">
        {migratedCount?.toLocaleString()}
        </Typography>
        <h1>Storage Migrated</h1>
        <Typography variant="h1" className="text-4xl">
        {storageMigratedCount?.toLocaleString()}
        </Typography>
        <h1>Last Doc</h1>
        <Typography variant="h1" className="text-4xl">
          {breakdown?.lastProcessedId|| '-'}
        </Typography>
        <h1>hasHtml</h1>
        <Typography variant="h1" className="text-4xl">
          {breakdown?.html.toLocaleString()|| '-'}
        </Typography>
        <h1>json</h1>
        <Typography variant="h1" className="text-4xl">
          {breakdown?.json.toLocaleString()|| '-'}
        </Typography>
        <h1>json2</h1>
        <Typography variant="h1" className="text-4xl">
          {breakdown?.json2.toLocaleString()|| '-'}
        </Typography>
        <h1>noBlob</h1>
        <Typography variant="h1" className="text-4xl">
          {breakdown?.noBlob.toLocaleString() || '-'}
        </Typography>
        <h1>updated</h1>
        <Typography variant="h1" className="text-4xl">
          {breakdown?.updatedAt || '-'}
        </Typography>
        <h1>Sum</h1>
        <Typography variant="h1" className="text-4xl">
          {(breakdown?.noBlob + breakdown?.json + breakdown?.html).toLocaleString()}
        </Typography>
        <h1>To Storage Migrage</h1>
        <Typography variant="h1" className="text-4xl">
          {( breakdown?.json + breakdown?.html).toLocaleString()}
        </Typography>
        <h1>*** Remaining ***</h1>
        <Typography variant="h1" className="text-4xl">
          {( breakdown?.json + breakdown?.html - storageMigratedCount).toLocaleString()}
        </Typography> */}
        <h1>Count</h1>
        <Typography variant="h1" className="text-4xl">
          {listingAggregationsCount}
        </Typography>
      {/* <h1>BPath count </h1>
      <Typography variant="h1" className="text-4xl">
        {bPATHCount?.toLocaleString()}
      </Typography>
      <h1>listing_scrapes with HTML count </h1>
      <Typography variant="h1" className="text-4xl">
        {HTMLCount?.toLocaleString()}
      </Typography>
      <h1>hasHTML count </h1>
      <Typography variant="h1" className="text-4xl">
        {HASHTMLCount?.toLocaleString()}
      </Typography>
      <h1>hasJson count </h1>
      <Typography variant="h1" className="text-4xl">
        {HASJSONCount?.toLocaleString()}
      </Typography>
      <h1>hasJson2 count </h1>
      <Typography variant="h1" className="text-4xl">
        {HASJSON2Count?.toLocaleString()}
      </Typography>
      <h1>noBlob count </h1>
      <Typography variant="h1" className="text-4xl">
        {noBlobCount?.toLocaleString()}
      </Typography>
      <h1>ALL listings_scrapes </h1>
      <Typography variant="h1" className="text-4xl">
        {allListingScrapes?.toLocaleString()}
      </Typography>
      <h1>JSON2 count </h1>
      <Typography variant="h1" className="text-4xl">
      <span>{JSON2Count}</span>
      </Typography> */}
      <Card className="max-w-sm mx-auto p-4 shadow-md">
        <p className="text-4xl font-mono">{loading ? "Loading..." : "Ready"}</p>
        <Button onClick={fetchCount} className="w-full">
          Refresh Count
        </Button>
      </Card>
    </div>
  );
};

export default ListingAggregationStatus;
